module.exports = __webpack_public_path__ + "img/shooting05.a13726e5.jpeg";